import { render, staticRenderFns } from "./SelectNumberOfChildren.vue?vue&type=template&id=e6b34ef8"
import script from "./SelectNumberOfChildren.vue?vue&type=script&lang=js"
export * from "./SelectNumberOfChildren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports